import { render, staticRenderFns } from "./Type3.vue?vue&type=template&id=35a635b2&scoped=true"
import script from "./Type3.vue?vue&type=script&lang=js"
export * from "./Type3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a635b2",
  null
  
)

export default component.exports